import React, { forwardRef, ReactElement } from 'react'
import { Icon, IconBase, IconWeight } from '@phosphor-icons/react'

const getWeights = (color?: string) => {
    const regularSvg: ReactElement = (
        <path
            d="M128 192C163.346 192 192 163.346 192 128C192 92.6538 163.346 64 128 64C92.6538 64 64 92.6538 64 128C64 163.346 92.6538 192 128 192Z"
            stroke={color}
            strokeWidth="16"
        />
    )
    const fillSvg: ReactElement = (
        <path
            d="M128 192C163.346 192 192 163.346 192 128C192 92.6538 163.346 64 128 64C92.6538 64 64 92.6538 64 128C64 163.346 92.6538 192 128 192Z"
            fill={color}
        />
    )
    return new Map<IconWeight, ReactElement>([
        ['regular', regularSvg],
        ['fill', fillSvg],
    ])
}

/**
 * Phosphor custom icon based on https://github.com/phosphor-icons/react#custom-icons
 * Modified how color works to match the icon design
 */
const BigDot: Icon = forwardRef((props, ref) => {
    return <IconBase ref={ref} {...props} weights={getWeights(props.color)} fill="None" />
})

BigDot.displayName = 'BigDot'

export default BigDot
